import { NetfixLicensesColumns } from "./_components/Columns";
import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "./DataTable";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/NetflixList.css";
import loadingGif from "../../Assets/Imgs/loading2.gif";
import NewLicensePopup from "./_components/NewLicensePopup";
import { DataContext } from "../../Services/DataContext";

const NetflixList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState("");
    const [showNewPopup, setShowNewPopup] = useState(false);

    const { netflixLicenses } = useContext(DataContext);

    useEffect(() => {
        if (netflixLicenses) {
            setLoading(false);
        }
    }, [netflixLicenses]);
    
    const filteredData = statusFilter
        ? netflixLicenses.filter((item) => item.status === statusFilter)
        : netflixLicenses;

    if (loading) return (
        <div className="netflix-loading-overlay">
            <div className="netflix-loading-content">
                <p>Chargement des Informations...</p>
                <img src={loadingGif} alt="Chargement" />
            </div>
        </div>
    );

    return (
        <div>
            <SideBar />
            <div className='netflix-list'>
                <h3 className="netflix-title">Listes des Comptes Netflix</h3>

                <div className="netflix-filter-container">
                    <div className="netflix-add-button" onClick={() => setShowNewPopup(true)}>
                        <p>+ Ajouter un compte</p>
                    </div>
                    <select
                        className="netflix-select"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="">Tous</option>
                        <option value="available">Disponibles</option>
                        <option value="expired">Expirées</option>
                        <option value="sold">Vendus</option>
                    </select>
                </div>
                <DataTable columns={NetfixLicensesColumns} data={filteredData} />
            </div>
            {showNewPopup && <NewLicensePopup onClose={() => setShowNewPopup(false)} />}
        </div>
    );
};

export default NetflixList;